/*
some random js helpers
 */

export default{
  debounce(fn, wait){
    let timer;
    return function(...args) {
      if (timer) clearTimeout(timer); // clear any pre-existing timer
      const context = this; // get the current context
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, wait);
    }
  },
  pluralize( word, count= 1, suffix = 's'){
    return count === 1 ? word : word + suffix;
  },
  scrolldown(name = null) {
    let height = $(document).height();
    if (typeof(name) === 'string') {
      let element = document.getElementById(name);
      if (element) {
        height = window.scrollY + element.getBoundingClientRect().top - 132;  // height of navbars and 10 px change
      }
      else{
        return;
      }
    }
    // const height = document.activeElement.parentElement.offsetHeight;
    $("html, body").animate({ scrollTop: height }, 1000);
  },
  sleep (time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  },
}



// WEBPACK FOOTER //
// ./src/lib/helpers.js